
/**
		Компонент модального окна.
		Минимальный сетап:
		<modal :visible.sync="show_popup">
			<h1 slot="body">Россия Живёт Дорогами!</h1>
		</modal>

		Сетап с кнопками:
		<modal :visible.sync="show_popup">
			<h1 slot="body">Россия Живёт Дорогами!</h1>
			<button slot="footer" @click="togglePopup(false)">Понятно, запустить фотонные торпеды</button>
		</modal>

		!! если нужен контроль за закрытием (сайдэффекты типа подтверждения закрытия или применения правок)
		!! то нужно вместо .sync писать modal :visible="show_popup" @update:visible="togglePopup"

		Что нужно добавить в инстанс чтобы подключить modal:
			data: function() {
				return {
					show_popup: false,
				}
			},
			methods: {
				togglePopup: function(bShow) {
					this.show_popup = !!bShow;
				},
			}

	*/
export default {
	name: 'Modal',
	props: {
		visible: {
			// увага! признак показа должен быть прибинден с модификатором sync
			// https://vuejs.org/v2/guide/components-custom-events.html#sync-Modifier
			type: Boolean,
			default: false,
		},
		closeable: {
			type: Boolean,
			default: true,
		},
		wide: {
			type: Boolean,
			default: true,
		},
		big_height: {
			type: Boolean,
			default: true,
		},
		min_height: {
			type: Boolean,
			default: false,
		},
		enable_scroll_top: {
			type: Boolean,
			default: false,
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showFooter: {
			type: Boolean,
			default: true,
		},
		upper_footer: {
			type: Boolean,
			default: false,
		},
		pending: {
			type: Boolean,
			default: false,
		},
		nopadding: {
			// для стилизации без паддингов и прокрутки, когда за прокрутку должно отвечать тело модалки
			type: Boolean,
			default: false,
		},
	},
	data: function () {
		/*var wrapClassList = [];
			for (let slotName in this.$slots) {
				wrapClassList.push('hasSlot-' + slotName);
			}*/
		return {
			wrapClassName: '', //wrapClassList.join(' '),
		};
	},
	computed: {
		c_visible: function () {
			return this.visible;
		},
	},
	methods: {
		doClose: function () {
			if (this.closeable === false) {
				return;
			}
			this.$emit('update:visible', false);
			//this.c_visible = false;
			this.$emit('close');
		},
		handleEscKey: function (evt) {
			if (evt.key === 'Escape' && this.c_visible === true) {
				this.doClose();
			}
		},
		preventOuterEffect: function (evt) {
			// иначе такое PIRS2018-485. Если тупо написать @click.prevent.stop то перестанет работать аутентификация
			if (evt.target === this.$refs.wrapperRef) {
				evt.preventDefault();
				evt.stopPropagation();
			}
		},
		scrollTop: function () {
			this.$refs.bodyRef.scrollTo(0, 0);
		},
	},
	mounted: function () {
		document.addEventListener('keydown', this.handleEscKey);
	},
	destroyed: function () {
		document.removeEventListener('keydown', this.handleEscKey);
	},
};
